import JustValidate from '../../../../../../../../build/node_modules/just-validate';
//stop form from submitting
document.addEventListener("DOMContentLoaded", () => {
    const script = document.createElement('script');
    script.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js';
    script.async = true;
    document.body.appendChild(script);
    new Vue({
        el: '#financialGoalGetter', // Target the element with id "latestArticle"
        data: {
            success: false,
            hasResults: false,
            slides:[],
            section: 'intro-slide',
            question: null,
            progress:0,
            submitting: false,
            results: {},
        },
        methods: {
            fixSlidesHeight: function() {

                var slidesContainer = document.querySelector('#slides');
                slidesContainer.style.height = 'calc(100dvh - 132px - 50px)';
                var slides = document.querySelectorAll('.slide.active');
                var minHeight = 0;
                slides.forEach(function (slide) {
                    //if slide.id contains age-group
                    slide.style.height = 'auto';
                    if (slide.offsetHeight > minHeight) {
                        minHeight = slide.offsetHeight;
                    }

                    if(slide.id.includes('age-group')){
                        var questions = document.querySelectorAll('.question.active');
                        questions.forEach(function (question) {
                            question.style.height = 'auto';
                            if (question.offsetHeight+60 > minHeight) {
                                minHeight = question.offsetHeight+60;
                            }
                            question.style.height = '100%';
                        });
                    }
                    slide.style.height = '100%';
                });
                //if slidesContainer height is less than minHeight, set slidesContainer height to minHeight
                if (slidesContainer.offsetHeight < minHeight) {
                    slidesContainer.style.height = minHeight + 'px';
                }
            },
            formatPhoneNumber: function(textfield) {
                let input = textfield.value;
                input = input.replace(/\D/g, '');
                input = input.substring(0, 10);
                let size = input.length;
                if (size == 0) {
                    input = input;
                } else if (size < 4) {
                    input = '(' + input;
                } else if (size < 7) {
                    input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6);
                } else {
                    input = '(' + input.substring(0, 3) + ') ' + input.substring(3, 6) + '-' + input.substring(6, 10);
                }
                textfield.value = input;
            },
            checkFields: function() {
                const formControls = document.querySelectorAll('.form-control');
                formControls.forEach((input) => {
                    if (input.value) {
                        input.parentNode.classList.add('filled');
                    } else {
                        input.parentNode.classList.remove('filled');
                    }
                });
            },
            clearAllFields: function() {
                document.querySelectorAll(
                    'input:not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), select:not([type="hidden"])'
                ).forEach(function (element) {
                    element.value = '';
                });
                document.querySelectorAll(
                    'textarea:not([type="button"]):not([type="submit"]):not([type="reset"]):not([type="hidden"]):not([type="checkbox"]):not([type="radio"]), textarea:not([type="hidden"])'
                ).forEach(function (element) {
                    element.value = '';
                });
                document.querySelectorAll('select').forEach(function (element) {
                    element.selectedIndex = 0;
                });
            },
            closeButton: function() {
                const closeButton = document.querySelector("#success-wrapper .close");
                if (closeButton) {
                    closeButton.addEventListener("click", () => {
                        const successWrapper = document.getElementById("success-wrapper");
                        const buttons = document.querySelectorAll(".buttons button");
                        const successElement = document.getElementById("success");
                        if (successWrapper) {
                            successWrapper.classList.remove("active");
                            successWrapper.style.display = "none";
                        }
                        if (buttons) {
                            buttons.forEach((button) => {
                                button.classList.remove("disabled");
                            });
                        }
                    });
                }
            },
            onRecaptchaLoadCallback: function() {
                var inlineBadge = document.getElementById('inline-badge');
                if (inlineBadge) {
                    inlineBadge.remove();
                }
                var holder = document.getElementById('holder');
                if (holder) {
                    holder.innerHTML = '<div id="inline-badge"></div>';
                    var clientId = turnstile.render('#inline-badge', {
                        theme: 'light',
                        sitekey: '0x4AAAAAAAMxpMpvfowZaDxh',
                        callback: function (token) {
                            if (token) {
                                console.log('Recaptcha Successful');
                            }
                        },
                    });
                    var recaptchaLogo = document.querySelector('.grecaptcha-logo iframe');
                    if (recaptchaLogo) {
                        recaptchaLogo.setAttribute('tabindex', '-1');
                    }
                    var recaptchaResponse = document.getElementById('g-recaptcha-response');
                    if (recaptchaResponse) {
                        recaptchaResponse.setAttribute('aria-hidden', 'true');
                    }
                }
            },
            initiateForm: function() {
                const form = document.querySelector('.worxForm');
                const submitButton = form.querySelector('button[type="submit"]');
                if (form) {
                    this.checkFields();
                    const telInput = document.getElementById('tel');
                    if (telInput) {
                        telInput.addEventListener('input', function() {
                              this.formatPhoneNumber(telInput);
                        });
                    }
                    document.querySelectorAll('.control-label').forEach(function (label) {
                        label.addEventListener('click', function () {
                            label.nextElementSibling.focus();
                        });
                    });

                    document.querySelectorAll('.form-control').forEach(function (input) {
                        input.addEventListener('focus', function () {
                            input.parentNode.classList.add('filled');
                        });
                        input.addEventListener('blur', function () {
                            if (!input.value) {
                                input.parentNode.classList.remove('filled');
                            }
                        });
                    });

                    document.querySelectorAll('select.form-control').forEach(function (select) {
                        select.addEventListener('change', checkFields);
                    });

                    const requiredFields = form.querySelectorAll('.required');

                    const fieldRules = Array.from(requiredFields).reduce((rules, field) => {
                        const fieldName = field.getAttribute('name');
                        const fieldType = field.getAttribute('type');
                        if (fieldName) {
                            rules[fieldName] = {
                                required: true,
                                id: '#' + fieldName,
                            };
                            if (fieldType === 'email') {
                                rules[fieldName].type = 'email';
                            }
                        }
                        return rules;
                    }, {});


                    const validator = new JustValidate('.worxForm');

                    Object.entries(fieldRules).forEach(([fieldName, fieldConfig]) => {
                        const { id, type } = fieldConfig;
                        const rules = [{ rule: 'required' }];
                        if (type === 'email') {
                            rules.push({ rule: 'email' });
                        }
                        validator.addField(id, rules);
                    });
                    validator.onSuccess(() => {
                        submitButton.disabled = true; // Disable submit button to prevent multiple submissions
                        if (document.getElementById('payment')) {
                            createToken(form).then(() => {
                                submitButton.disabled = false; // Enable submit button after token creation
                            }).catch((error) => {
                                console.error('Token creation error:', error);
                                submitButton.disabled = false; // Enable submit button if token creation fails
                            });
                        } else {
                            this.sendFormSubmission(form,submitButton);
                        }
                    });
                }
            },
            sendFormSubmission: function(form,submitButton) {
                const successElement = document.getElementById('success-message');
                if (successElement) {
                    successElement.innerHTML = '<h4>Loading</h4>';
                    successElement.classList.add('loading');
                }
                const successWrapper = document.getElementById('success-wrapper');
                if (successWrapper) {
                    successWrapper.style.display = 'block';
                    successWrapper.classList.add('active');
                }
                const formAction = form.getAttribute('action');
                const formData = new FormData(form);
                const xhr = new XMLHttpRequest();
                xhr.open(form.method, formAction);
                xhr.onload = function () {
                    if (xhr.status === 200) {
                        const result = JSON.parse(xhr.responseText);
                        dataLayer.push({
                            event: 'VirtualPageview',
                            virtualPageURL: form.action + '/thank-you',
                            virtualPageTitle: document.querySelector('h1').textContent + ' Thank You',
                        });
                        if (typeof hj !== 'undefined') {
                            hj('formSubmitSuccessful');
                        }
                        if (successElement) {
                            successElement.innerHTML = result.message;
                            successElement.classList.remove('loading');
                            successElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        }
                    }
                };
                xhr.send(formData);
                submitButton.disabled = false;
            },
            initiateAfterLoad: function() {
                this.$nextTick(() => {
                    this.onRecaptchaLoadCallback();
                    this.offsite();
                    this.closeButton();
                    this.initiateForm();

                });
            },
            offsite: function() {
                // Select elements with the class 'offsite'
                const offsiteElements = document.querySelectorAll('.offsite');

                // Add click event listener to each element
                offsiteElements.forEach(element => {
                    //remove event listener if it's aready added
                    element.addEventListener('click', function (e) {
                        let answer;

                        // Check for the 'data-offsite' attribute
                        if (this.getAttribute('data-offsite')) {
                            answer = confirm(this.getAttribute('data-offsite'));
                        } else {
                            answer = confirm("Please be advised that you are leaving our website. This link is provided as a courtesy. We do not endorse or control the content of third party websites.");
                        }

                        // Prevent default action if user chooses 'Cancel'
                        if (!answer) {
                            e.preventDefault();
                        }
                    });
                });
            },
            startOver: function() {
                localStorage.removeItem('financialGoalGetter');
                this.success = false;
                this.hasResults = false;
                this.slides = [];
                this.section = 'intro-slide';
                this.question = null;
                this.progress = 0;
                this.submitting = false;
                this.results = {};
                document.getElementById('financialGoalGetter').classList.add('loading');
                fetch('/api/get_questions')
                    .then(response => response.json())
                    .then(data => {
                        // Update the Vue data properties with the fetched data
                        this.success = data.success;
                        this.slides = data.slides;
                        this.$nextTick(() => {
                            this.fixSlidesHeight();
                        });
                        document.getElementById('financialGoalGetter').classList.remove('loading');
                    })
                    .catch(error => {
                            console.error('Error fetching latest article:', error);
                        }
                    );
            },
            goToFirstName: function() {
                this.section = 'name-slide';
                this.progress = '25';
                this.$nextTick(() => {
                    this.fixSlidesHeight();
                });
            },
            goToAge: function() {
                this.section = 'age-slide';
                this.progress = '50';
                this.$nextTick(() => {
                    this.fixSlidesHeight();
                });
            },
            goToIntro: function() {
                this.section = 'intro-slide';
            },
            submitAge: function(slide) {
                if(slide.value){
                    slide.error = false;
                    this.section = 'age-group';
                    this.progress = '75';
                }else{
                    slide.error = true;
                }
                this.$nextTick(() => {
                    this.fixSlidesHeight();
                });
            },
            updateRadio(question, value) {
                question.value = value;
            },
            updateCheckbox(question, answer) {
                question.value = question.value || [];
                const index = question.value.indexOf(answer);
                if (index === -1) {
                    // Answer not in array, add it
                    question.value.push(answer);
                } else {
                    // Answer in array, remove it
                    question.value.splice(index, 1);
                }
            },
            goToPrevious: function(slide) {
                let slideAdvance = 1;
                while (slide.currentSlide - slideAdvance >= 0) {
                    const previousQuestion = slide.questions[slide.currentSlide - slideAdvance];
                    // Check if we need to skip this question based on visibility conditions.
                    if (previousQuestion.visibilityQuestion) {
                        const visibilityValue = previousQuestion.visibilityQuestion;
                        const previousValue = slide.questions[slide.currentSlide - slideAdvance - 1]?.value;
                        if (visibilityValue !== previousValue) {
                            slideAdvance++; // Need to skip this one, check the next.
                            continue;
                        }
                    }
                    // Found the correct slide to move to.
                    slide.currentSlide -= slideAdvance;
                    break;
                }
                this.$nextTick(() => {
                    this.fixSlidesHeight();
                });
                this.progress = '75'; // Update progress if needed.
            },
            submitQuestion: function(question, slide) {
                let slideAdvance = 1;
                while (slide.currentSlide + slideAdvance < slide.total) {
                    const nextQuestion = slide.questions[slide.currentSlide + slideAdvance];
                    // Check if the next question is visible based on the current answer.
                    if (nextQuestion.visibilityQuestion && question.value != nextQuestion.visibilityAnswer) {
                        slideAdvance++; // Need to skip, check the next.
                        continue;
                    }
                    // Found the correct slide to move to.
                    slide.currentSlide += slideAdvance;
                    break;
                }
                this.$nextTick(() => {
                    this.fixSlidesHeight();
                });
                if (slide.currentSlide == slide.total - 1) {
                    this.progress = '100'; // Last slide, mark progress as complete.
                }
            },
            formDataToJson: function(formData) {
                const formObj = {};

                for (const [key, value] of formData) {
                    // Check if the key already exists
                    if (Object.hasOwnProperty.call(formObj, key)) {
                        // If it's not already an array, convert it into an array
                        if (!Array.isArray(formObj[key])) {
                            formObj[key] = [formObj[key]];
                        }
                        // Add the new value to the array
                        formObj[key].push(value);
                    } else {
                        // If the key doesn't exist, add it directly
                        formObj[key] = value;
                    }
                }

                return JSON.stringify(formObj);
            },
            JsonToFormData: function(jsonString) {
                const dataObj = JSON.parse(jsonString);
                const formData = new FormData();

                for (const key in dataObj) {
                    if (Object.hasOwnProperty.call(dataObj, key)) {
                        const value = dataObj[key];
                        // If the value is an array, append each value under the same key
                        if (Array.isArray(value)) {
                            value.forEach(item => {
                                formData.append(key, item);
                            });
                        } else {
                            // If it's not an array, just append it directly
                            formData.append(key, value);
                        }
                    }
                }
                return formData;
            },
            submitResults: function() {
                this.submitting = true;
                //serialize the data from #slides form
                var form = document.getElementById('slides');
                var formData = new FormData(form);
                var formJson = this.formDataToJson(formData);
                //store data to local storage
                localStorage.setItem('financialGoalGetter', formJson);
                //send data to server
                fetch('/api/goal_getter/'+JSON.parse(formJson)['age_group'], {
                    method: 'POST',
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        // Update the Vue data properties with the fetched data
                       this.submitting = false;
                       if(data.status == 'success'){
                           this.hasResults = true;
                           this.results = data;
                           this.initiateAfterLoad();
                       }
                    })
                    .catch(error => {
                        console.error('Error fetching latest article:', error);
                    });
            }
        },
        mounted() {
            window.addEventListener('resize', this.fixSlidesHeight);
            setInterval(function () {
                this.onRecaptchaLoadCallback();
            }, 150000);
            //check if local storage has data
            if(localStorage.getItem('financialGoalGetter')){
                document.getElementById('financialGoalGetter').classList.remove('loading');
                this.submitting = true;
                var formJson = localStorage.getItem('financialGoalGetter');
                const formData = this.JsonToFormData(formJson);
                this.submitting = true;
                fetch('/api/goal_getter/'+JSON.parse(formJson)['age_group'], {
                    method: 'POST',
                    body: formData
                })
                    .then(response => response.json())
                    .then(data => {
                        // Update the Vue data properties with the fetched data
                        this.submitting = false;
                        if(data.status == 'success'){
                            this.hasResults = true;
                            this.results = data;
                            this.initiateAfterLoad();
                        }
                    })
                    .catch(error => {
                        console.error('Error fetching latest article:', error);
                    });
            }else{
                fetch('/api/get_questions')
                    .then(response => response.json())
                    .then(data => {
                        // Update the Vue data properties with the fetched data
                        this.success = data.success;
                        this.slides = data.slides;
                        this.$nextTick(() => {
                          this.fixSlidesHeight();
                        });
                        document.getElementById('financialGoalGetter').classList.remove('loading');
                    })
                    .catch(error => {
                            console.error('Error fetching latest article:', error);
                        }
                    );
            }
        }
    });
});